import { useState, useEffect } from 'react';

const carouselItems = [
  {
    caption: '近くの店が流れる',
    image: 'https://static.readdy.ai/image/10d1ee7f672303b24e915f86db5d57f1/2451bc8ff042c944ea542c609d910c92.png'
  },
  {
    caption: '地図でサクッと探す',
    image: 'https://static.readdy.ai/image/10d1ee7f672303b24e915f86db5d57f1/8078b88697a98d9b2a4492ef830520b7.png'
  },
  {
    caption: '迷ったら保存しておく',
    image: 'https://static.readdy.ai/image/10d1ee7f672303b24e915f86db5d57f1/3a5ce50abe8635c0b6d3ef401cc63e0b.png'
  },
  {
    caption: '店の雰囲気を確認',
    image: 'https://static.readdy.ai/image/10d1ee7f672303b24e915f86db5d57f1/098814f857200c3b4c570db3922e1cfc.png'
  }
];

export default function Hero() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % carouselItems.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative pt-20 lg:pt-32 pb-12 lg:pb-20 overflow-hidden" style={{ background: 'linear-gradient(180deg, #FFF9E6 0%, #F5EDD8 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Mobile: Carousel First / Desktop: Text First */}
          <div className="order-1 lg:order-2 relative">
            <div 
              className="relative rounded-3xl p-6 lg:p-8 overflow-hidden"
              style={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
              }}
            >
              {/* Phone Mockup */}
              <div className="relative mx-auto" style={{ width: '280px', height: '560px', maxWidth: '100%' }}>
                <div 
                  className="absolute inset-0 bg-black rounded-[40px] p-3"
                  style={{ boxShadow: '0 30px 60px rgba(0,0,0,0.4)' }}
                >
                  <div className="relative w-full h-full bg-white rounded-[32px] overflow-hidden">
                    {/* Carousel Images */}
                    {carouselItems.map((item, index) => (
                      <div
                        key={index}
                        className={`absolute inset-0 transition-opacity duration-500 ${
                          index === currentIndex ? 'opacity-100' : 'opacity-0'
                        }`}
                      >
                        <img
                          src={item.image}
                          alt={item.caption}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Caption */}
              <div className="mt-4 lg:mt-6 text-center">
                <p className="text-white text-sm font-medium">
                  {carouselItems[currentIndex].caption}
                </p>
              </div>

              {/* Dots Indicator */}
              <div className="flex justify-center gap-2 mt-3 lg:mt-4">
                {carouselItems.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                      index === currentIndex ? 'bg-[#EDD92A] w-6' : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Mobile: Text Second / Desktop: Text First */}
          <div className="order-2 lg:order-1 space-y-5 lg:space-y-8">
            {/* Badge */}
            <div className="inline-block">
              <span className="bg-[#333333] text-white text-xs font-semibold px-4 py-2 rounded-full">
                Ver.0参加者募集中
              </span>
            </div>

            {/* Heading */}
            <div className="space-y-3 lg:space-y-4">
              <h1 className="hero-h1 text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#111111] leading-tight">
                空腹に、<br />
                検索は遅すぎる
              </h1>
              <p className="hero-sub text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold text-[#111111] leading-relaxed">
                スワイプで、<br />
                <span className="pl-4">"近場の候補"がすぐ分かる</span>
              </p>
              <p className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold text-[#111111] leading-relaxed">
                動画で決めて、即移動<br />
                <span className="pl-4">もう店選びで迷わない</span>
              </p>
            </div>

            {/* Subtext */}
            <div className="text-sm lg:text-base text-gray-600 leading-relaxed">
              <p>Ver.0は2026/3/27予定。いまは育成中。先行テスター/投稿者をLINEで募集。</p>
            </div>

            {/* Features List - Mobile: 1 item / Desktop: 3 items */}
            <ul className="space-y-2 lg:space-y-3">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-[#EDD92A] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-sm lg:text-base text-[#111111]">迷ったら保存。あとで悩まない</span>
              </li>
              <li className="hidden lg:flex items-start">
                <span className="w-2 h-2 bg-[#EDD92A] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-base text-[#111111]">近くの店を、縦動画でスワイプ</span>
              </li>
              <li className="hidden lg:flex items-start">
                <span className="w-2 h-2 bg-[#EDD92A] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="text-base text-[#111111]">投稿者は「食のログ」を動画で残せる</span>
              </li>
            </ul>

            {/* CTA Button - Single Primary */}
            <div className="hero-cta">
              <a
                href="https://lin.ee/PJ9odjt"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full lg:inline-block lg:w-auto bg-[#EDD92A] text-black font-bold px-8 py-4 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center whitespace-nowrap cursor-pointer"
                style={{ boxShadow: '0 6px 16px rgba(0,0,0,0.15)' }}
              >
                LINEで先行テスター/投稿者登録（無料）
              </a>
            </div>

            {/* Micro Copy */}
            <p className="text-xs text-gray-500">
              無料 / 通知は最小限 / いつでも停止OK
            </p>

            {/* Expectation Setting */}
            <p className="text-xs text-gray-500 italic">
              ※Ver.0初期は動画/店舗数が少ないです。参加者の投稿で増やしていきます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
